import React from 'react';
import { McProfile } from '../../../store/gamingStore';
import { Map, FolderOpen } from 'lucide-react';

interface Props {
  profile: McProfile;
}

const ProfileWorldsTab: React.FC<Props> = ({ }) => {
  // Worlds are stored locally in the profile's saves/ directory.
  // This component will eventually read from the filesystem via IPC.
  // For now it shows an empty state with a link to open the saves folder.

  return (
    <div className="max-w-7xl mx-auto px-6 py-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-sm font-semibold text-text-primary">Mondes</h2>
        <button className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-bg-secondary border border-border-color text-xs text-text-secondary hover:text-text-primary hover:border-gaming-accent/50 transition-colors">
          <FolderOpen className="w-3.5 h-3.5" />
          Ouvrir le dossier
        </button>
      </div>

      <div className="text-center py-16">
        <Map className="w-12 h-12 text-text-muted mx-auto mb-3" />
        <p className="text-sm text-text-secondary">Aucun monde sauvegardé</p>
        <p className="text-xs text-text-muted mt-1">
          Les mondes apparaîtront ici après avoir joué au moins une fois avec ce profil
        </p>
      </div>
    </div>
  );
};

export default ProfileWorldsTab;
